import { render, staticRenderFns } from "./ModalAlteracaoDepartamento.vue?vue&type=template&id=28e7a478&scoped=true&"
import script from "./ModalAlteracaoDepartamento.vue?vue&type=script&lang=js&"
export * from "./ModalAlteracaoDepartamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlteracaoDepartamento.vue?vue&type=style&index=0&id=28e7a478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7a478",
  null
  
)

export default component.exports